module.exports = __webpack_public_path__ + "img/hohlsaum_steingrau_ohneral.f26f214d.jpg";